/** @file The geometry Camera of the camera store at the runtime's CSS size. */
import { viewCamera } from '@pose2d/editor-geometry/viewCamera';
import type { Camera } from '@pose2d/geometry/types';
import { cameraStore } from '../../stores/cameraStore';
import type { RuntimeState } from './runtimeState';

/** viewCamera.toCamera(cameraStore, width, height). */
export function cameraOf(s: Pick<RuntimeState, 'width' | 'height'>): Camera {
  return viewCamera.toCamera(cameraStore.getState(), s.width, s.height);
}
